module.exports = __webpack_public_path__ + "images/_/programs/epsHybridAssembly/images/characters/apprenticePointingDiagonal-01628f9248ed94db92bf66a6d3f2ca75.png";


//////////////////
// WEBPACK FOOTER
// ./programs/epsHybridAssembly/images/characters/apprenticePointingDiagonal.png
// module id = 851
// module chunks = 2